import * as React from 'react';
import { cn } from './cn';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
  leftIcon?: React.ReactNode;
}

/** EDS text input — Design Bible §7.3. Height 44, radius 12, solid EDS focus ring (>= 3:1, WCAG 1.4.11). */
export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, invalid = false, leftIcon, ...props }, ref) => (
    <div className="relative">
      {leftIcon && (
        <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-eds-muted-fg" aria-hidden="true">
          {leftIcon}
        </span>
      )}
      <input
        ref={ref}
        aria-invalid={invalid || undefined}
        className={cn(
          'h-11 w-full rounded-eds-md border bg-eds-surface px-3.5 font-eds-body text-sm text-eds-fg',
          'placeholder:text-eds-muted-fg',
          'focus:outline-none focus:ring-2 focus:ring-eds-ring focus:border-eds-ring',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          invalid ? 'border-eds-danger focus:ring-eds-danger focus:border-eds-danger' : 'border-eds-border',
          leftIcon && 'pl-9',
          className,
        )}
        {...props}
      />
    </div>
  ),
);
Input.displayName = 'EdsInput';

export default Input;
